export const RESET = 'EXCMRELATION_UPDATE_RESET'
export const SET_ERROR = 'EXCMRELATION_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMRELATION_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMRELATION_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMRELATION_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMRELATION_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMRELATION_UPDATE_UPDATE_RETRIEVED'
